import { CarSpec } from 'noddi-types';
import { useAuthContext } from 'noddi-web';

/**
 * The viewer's user group that owns the car's wheel storage contract, if any.
 * Plate search is open to everyone — wheelStorage on a looked-up car is not
 * proof the viewer may add it. Badge/season come from getTireHotelsForCustomer.
 */
export const useWheelStorageOwnerGroup = () => {
  const { isLoggedIn, userData } = useAuthContext();

  return (car: Pick<CarSpec, 'wheelStorage'> | null | undefined) =>
    isLoggedIn
      ? userData?.user.userGroups.find((userGroup) =>
          car?.wheelStorage?.some((wheelStorage) => wheelStorage.userGroupId === userGroup.id)
        )
      : undefined;
};
